import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => {
  try {
    const token = localStorage.getItem('accessToken');
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (token && user) {
      return {
        id: user.id,
        role: user.role,
        email: user.email,
        accessToken: token,
        refreshToken: localStorage.getItem('refreshToken') || '',
      };
    }
  } catch (_) {}
  return {
    id: null,
    role: '',
    email: '',
    accessToken: '',
    refreshToken: '',
  };
};

const userSlice = createSlice({
  name: 'user',
  initialState: getInitialState(),
  reducers: {
    setUser: (state, action) => {
      const { user, tokens } = action.payload;

      state.id = user.id;
      state.role = user.role;
      state.email = user.email;
      state.accessToken = tokens.access;
      state.refreshToken = tokens.refresh;

      // Persist to localStorage so session survives refresh
      localStorage.setItem('accessToken', tokens.access);
      localStorage.setItem('refreshToken', tokens.refresh);
      localStorage.setItem('user', JSON.stringify(user));
    },

    clearUser: (state) => {
      state.id = null;
      state.role = '';
      state.email = '';
      state.accessToken = '';
      state.refreshToken = '';

      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;